import { Controller } from "@hotwired/stimulus"

const INPUT_NAME = "banner_generator_apply_sequence_form[banner_ids][]"

export default class extends Controller {
  static targets = ["source", "tile", "selection", "empty", "inputs"]
  static values = { banners: Object, jobSequences: Object, selected: Array }

  declare tileTargets: HTMLElement[]
  declare selectionTarget: HTMLElement
  declare emptyTarget: HTMLElement
  declare inputsTarget: HTMLElement
  declare sourceTarget: HTMLSelectElement
  declare bannersValue: Record<string, string>
  declare jobSequencesValue: Record<string, number[]>
  declare selectedValue: string[]

  selectedValueChanged() {
    this.render()
  }

  toggle(event: Event) {
    const id = (event.currentTarget as HTMLElement).dataset.bannerId!
    this.selectedValue = this.selectedValue.includes(id)
      ? this.selectedValue.filter((i) => i !== id)
      : [...this.selectedValue, id]
  }

  remove(event: Event) {
    const id = (event.currentTarget as HTMLElement).dataset.bannerId!
    this.selectedValue = this.selectedValue.filter((i) => i !== id)
  }

  moveLeft(event: Event) {
    const id = (event.currentTarget as HTMLElement).dataset.bannerId!
    const ids = [...this.selectedValue]
    const index = ids.indexOf(id)
    if (index <= 0) return
    ;[ids[index - 1], ids[index]] = [ids[index], ids[index - 1]]
    this.selectedValue = ids
  }

  sourceChanged() {
    const ids = this.jobSequencesValue[this.sourceTarget.value]
    if (!ids) return
    // Banner, die nicht (mehr) fertig sind, fehlen in bannersValue
    this.selectedValue = ids.map(String).filter((id) => id in this.bannersValue)
  }

  private render() {
    const ids = this.selectedValue

    this.tileTargets.forEach((tile) => {
      const position = ids.indexOf(tile.dataset.bannerId!)
      const badge = tile.querySelector<HTMLElement>(".sequence-apply-badge")
      tile.classList.toggle("btn-primary", position >= 0)
      tile.classList.toggle("btn-outline-secondary", position < 0)
      if (badge) {
        badge.textContent = position >= 0 ? String(position + 1) : ""
        badge.style.display = position >= 0 ? "" : "none"
      }
    })

    this.selectionTarget.replaceChildren(...ids.map((id, index) => this.selectionItem(id, index)))
    this.emptyTarget.style.display = ids.length > 0 ? "none" : ""

    this.inputsTarget.replaceChildren(...ids.map((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = INPUT_NAME
      input.value = id
      return input
    }))
  }

  private selectionItem(id: string, index: number): HTMLElement {
    const item = document.createElement("div")
    item.className = "border rounded p-1 text-center"

    const img = document.createElement("img")
    img.src = this.bannersValue[id]
    img.style.maxHeight = "60px"
    img.style.maxWidth = "140px"
    img.className = "d-block mb-1"
    item.appendChild(img)

    const actions = document.createElement("div")
    actions.className = "d-flex justify-content-between align-items-center small"
    actions.appendChild(this.actionButton(id, "moveLeft", "fa-arrow-left", index === 0))
    const position = document.createElement("span")
    position.textContent = String(index + 1)
    actions.appendChild(position)
    actions.appendChild(this.actionButton(id, "remove", "fa-times", false))
    item.appendChild(actions)
    return item
  }

  private actionButton(id: string, action: string, icon: string, disabled: boolean): HTMLButtonElement {
    const button = document.createElement("button")
    button.type = "button"
    button.className = "btn btn-link btn-sm p-0"
    button.disabled = disabled
    button.dataset.bannerId = id
    button.dataset.action = `sequence-apply#${action}`
    button.innerHTML = `<i class="fas ${icon}"></i>`
    return button
  }
}
